import { Form } from "react-bootstrap";


const CenteredForm = ({children, onSubmit}) => {


    return (
        <div className="col-12 h-100 py-lg-5 d-flex justify-content-center align-items-center">
            <Form onSubmit={onSubmit} className="h-100 h-tab-60 h-tab-ls-75 col-12 col-tab-7 col-tab-ls-5 col-lg-4 bg-darkest rounded px-4 py-4 d-flex flex-column justify-content-between align-items-center overflow-y-auto" >
                {children}
            </Form>
        </div>
    );
}

export default CenteredForm;